import {
  ConversationStatus,
  MeetingBookingStatus
} from 'generated-graphql/types';
import { CampaignType } from 'services/campaign/types';
import { acceptedStatuses, bookedMeetingStatuses } from '../constants/statuses';

// On a scheduling campaign, COMPLETED covers both a booking and a timeout, and
// COMPLETED_MEETING_REQUESTED is written when the booking link is sent. Only
// the booking tells the outcome apart.
export const getCampaignDisplayStatus = ({
  status,
  campaignType,
  meetingBookingStatus
}: {
  status: ConversationStatus;
  campaignType?: CampaignType | null;
  meetingBookingStatus?: MeetingBookingStatus | null;
}): ConversationStatus => {
  if (campaignType !== CampaignType.SCHEDULING) return status;

  if (
    status !== ConversationStatus.Completed &&
    !acceptedStatuses.includes(status)
  ) {
    return status;
  }

  return meetingBookingStatus &&
    bookedMeetingStatuses.includes(meetingBookingStatus)
    ? ConversationStatus.CompletedMeetingRequested
    : ConversationStatus.Completed;
};
